import { useAppDispatch, useAppSelector } from "../../app/hooks";
import classes from "./BtcUserDk.module.css";
import {
  Avatar,
  Box,
  Button,
  CardActions,
  Checkbox,
  Chip,
  createTheme,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  IconButton,
  Stack,
  ThemeProvider,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { Card, CardContent, CardHeader } from "@mui/material";
import { useEffect } from "react";
import dayjs from "dayjs";
import "dayjs/locale/en-gb";
import { selectGrp, selectUsername } from "../../features/auth/authSlice";
import {
  getAllBtcDk,
  getBtcDkLog,
  removeBtcDk,
  updateBtcDk,
} from "../../services/btc/btcApi";
import {
  deleteBtcDk,
  editBtcDk,
  selectBtc,
  setBtcDsDk,
} from "../../features/btc/btcSlice";
import { useState } from "react";
import { BtcTitle, formatN, MyBtcLayout, PdfModal } from "./BtcAdmin.js";
import { LularDatePicker2 } from "./ngayAl.js";
import { getLunarMonthStartEnd2 } from "./ngayAl.js";
import { getLunarMonthStartEnd } from "./ngayAl.js";
import {
  getLunarDate,
  getYearCanChi,
  jdn2date,
} from "../../utils/amlich-hnd";
import { ConfirmButton } from "../dialog/ConfirmButton.js";
import { blueGrey, green, purple, yellow } from "@mui/material/colors";
import InfoIcon from "@mui/icons-material/Info";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";

const BtcUser = ({ navigate, params = {} }) => {
  console.log("BtcUser");
  const dispatch = useAppDispatch();

  // select
  const user = useAppSelector(selectUsername);
  const btc = useAppSelector(selectBtc);
  const grp = useAppSelector(selectGrp);

  // state
  const [ngayAL, setNgayAl] = useState(() => {
    if (btc.start) {
      return getDateAL(dayjs(btc.start));
    }
    return getDateAL();
  });
  const [curDateAL] = useState(getDateAL());
  console.log("ngayAL", ngayAL, "btcDsDk", btc.btcDsDk);
  const [pending, setPending] = useState(true);
  const [dkLog, setDkLog] = useState();
  const [openPdf, setOpenPdf] = useState(false);
  const [pdfBlobUrlOrUrl, setPdfBlobUrlOrUrl] = useState(null);

  // load data
  useEffect(() => {
    var load = async () => {
      console.log("BtcUser load");
      const [startAl, endAL] = getLunarMonthStartEnd2(ngayAL);
      const [start, end] = [ngayALToDL(startAl), ngayALToDL(endAL)];
      if (user === btc.email && start === btc.start && end === btc.end) {
        setPending(false);
        return;
      }

      console.log("fetch data: ", user, start, end);
      var res = await getAllBtcDk({
        email: user,
        start: start,
        end: end,
        grp,
      });
      if (!res.error) {
        dispatch(
          setBtcDsDk({
            btcDsDk: res.result,
            email: user,
            start: start,
            end: end,
          }),
        );
      } else {
        console.error(res.error);
        dispatch(
          setBtcDsDk({
            btcDsDk: [],
            email: user,
            start: start,
            end: end,
          }),
        );
      }

      setPending(false);
    };
    load();
  }, [btc.email, btc.end, btc.start, dispatch, grp, ngayAL, user]);

  if (pending) {
    return <>Loading...</>;
  }

  const lst = btc.btcDsDk ? btc.btcDsDk.filter((dk) => !dk.deleted) : [];

  async function handleLog(id) {
    // get log
    const { result, error } = await getBtcDkLog({ itemId: id, grp });
    if (error) {
      console.error(error);
    } else {
      setDkLog({ id, logs: result });
    }
    // show log
    console.log(result);
  }
  function handleEdit(id) {
    navigate("/BtcUserDk", { id: id, editBy: "user", btcUserEmail: user });
  }
  function handleAdd() {
    navigate("/BtcUserDk", {
      id: null,
      btcUserEmail: user,
      ngayAL: curDateAL.month === ngayAL.month ? curDateAL : ngayAL,
    });
  }
  async function handleDelete(id) {
    // var { error } = await removeBtcDk(id, grp);
    // if (!error) {
    //   dispatch(deleteBtcDk({ id }));
    // }
    var changes = { deleted: true };
    var { error } = await updateBtcDk(id, changes, grp);
    if (!error) {
      dispatch(editBtcDk({ id, changes }));
    }
  }
  const title = <BtcTitle navigate={navigate}></BtcTitle>;
  const footer = <div></div>;
  const screenOrientation = 0; // 0:landscape
  function getNgayAl(z_ngay) {
    const ngayDL = dayjs(z_ngay);
    const ngayAL = getLunarDate(
      ngayDL.date(),
      ngayDL.month() + 1,
      ngayDL.year(),
    );
    return `${ngayAL.day}/${ngayAL.month}/${getYearCanChi(ngayAL.year)}`;
  }
  

  return (
    <MyBtcLayout title={title} footer={footer}>
      <Stack
        direction={"column"}
        spacing={{ xs: 1, sm: 2 }}
        sx={
          screenOrientation
            ? { display: "flex", flexDirection: "column", height: "100%" }
            : {
                display: "flex",
                flexDirection: "column",
                height: "100%",
                overflow: "auto",
              }
        }
      >
        {LularDatePicker2(ngayAL, setNgayAl)}
        <div
          style={
            screenOrientation
              ? { flexGrow: 8, overflow: "auto" }
              : { flexGrow: 8 }
          }
        >
          <Stack direction={"column"} spacing={{ xs: 1, sm: 2 }}>
            {lst.map((dk, i) => {
              var gio = dk.gio ? dk.gio.slice(0, 5) : "00:00";
              const total = CalcTotal(dk.dsQuy);
              const isImage = dk.bill?.startsWith("data:image/");
              return (
                <div
                  key={i}
                  style={{
                    backgroundColor: dk.bill ? "whitesmoke" : "yellow",
                  }}
                >
                  <Card>
                    <CardHeader
                      title={gio + " " + getNgayAl(dk.ngay)}
                      subheader={total}
                      action={
                        <IconButton
                          aria-label="log"
                          onClick={() => handleLog(dk.id)}
                        >
                          <InfoIcon />
                        </IconButton>
                      }
                    ></CardHeader>

                    <CardContent>
                      <Box style={{ margin: "0.5rem" }}>
                        {dk.bill && (
                          <SmallPreview
                            value={dk.bill}
                            onOpen={() => {
                              setOpenPdf(true);
                              setPdfBlobUrlOrUrl(dk.bill);
                            }}
                          />
                        )}
                        {dk.note && <div>{"Ghi chú: " + dk.note}</div>}
                      </Box>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          flexWrap: "wrap",
                        }}
                      >
                        {dk.dsQuy.map((quy, j) => (
                          <div key={j} style={{ margin: "0.5rem" }}>
                            <Chip
                              avatar={<Avatar>{quy.msQuy}</Avatar>}
                              label={`${quy.soLuong}${quy.donVi}`}
                            />
                          </div>
                        ))}
                      </div>
                    </CardContent>
                    <CardActions>
                      <Stack
                        direction={"row"}
                        sx={{ justifyContent: "space-between", width: "100%" }}
                      >
                        {/* <Button
                          size="small"
                          onClick={() => handleLog(dk.id)}
                        >
                          {"Log"}
                        </Button> */}
                        <div className={classes.row_space}>
                          <div></div>
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <Button
                              size="small"
                              onClick={() => handleEdit(dk.id)}
                            >
                              {"Sửa"}
                            </Button>
                            <ConfirmButton
                              onOk={() => handleDelete(dk.id)}
                              title={"Xác nhận xóa"}
                              message={"Bạn có muốn xóa không?"}
                            >
                              <Button size="small">{"Xóa"}</Button>
                            </ConfirmButton>
                          </div>
                        </div>
                      </Stack>
                    </CardActions>
                  </Card>
                </div>
              );
            })}
          </Stack>
          <div
            style={{
              marginTop: "1rem",
              display: "flex",
              justifyContent: "center",
              backgroundColor: "aliceblue",
            }}
          >
            <IconButton onClick={handleAdd}>
              <AddIcon></AddIcon>
            </IconButton>
          </div>
        </div>
      </Stack>
      {dkLog && renderLogDlg(dkLog, () => setDkLog())}

      <PdfModal
        open={openPdf}
        onClose={() => setOpenPdf(false)}
        src={pdfBlobUrlOrUrl}
      ></PdfModal>
    </MyBtcLayout>
  );
};
export function renderLogDlg(dkLog, onClose) {
  return (
    <Dialog
      open={true}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{"ID: " + dkLog.id}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <DkLog {...dkLog}></DkLog>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} autoFocus>
          {"OK"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
const theme = createTheme({
  palette: {
    myprimary: green,
    mysecondary: yellow,
  },
});

const DkLog = ({ id, logs }) => {
  return (
    <ThemeProvider theme={theme}>
      <Stack direction={"column"} spacing={2}>
        {logs
          .sort((a, b) => a.timestamp - b.timestamp)
          .map((log, i) => {
            return renderLogCard();

            function renderLogCard() {
              const dk = JSON.parse(log.json);
              const isImage = dk?.bill?.startsWith("data:image/");
              const isPdf = dk?.bill?.startsWith("data:application/pdf");

              return (
                <Card
                  key={i}
                  sx={
                    log.action === "create"
                      ? { backgroundColor: theme.palette.primary.light }
                      : { backgroundColor: theme.palette.secondary.light }
                  }
                >
                  <CardHeader
                    title={log.timestamp.toDate().toLocaleString()}
                  ></CardHeader>
                  <CardContent>
                    {/* {log.json} */}
                    {dk.dsQuy && rendDsQuy()}
                    {dk.bill &&
                      (isImage ? (
                        <img alt="bill" src={dk.bill}></img>
                      ) : (
                        <iframe
                          src={dk.bill}
                          title="PDF viewer"
                          style={{
                            width: "100%",
                            height: "100vh",
                            border: "none",
                          }}
                        />
                      ))}
                    {dk.note && renderNote()}
                    <Stack
                      direction={"row"}
                      sx={{ justifyContent: "space-between" }}
                    >
                      <Box className={classes.row_y_center} m={1}>
                        <FormControlLabel
                          label="Xác nhận"
                          sx={{ whiteSpace: "nowrap" }}
                          control={<Checkbox checked={!!dk.xacNhan} />}
                        />
                        <FormControlLabel
                          label="Xóa"
                          sx={{ whiteSpace: "nowrap" }}
                          control={<Checkbox checked={!!dk.deleted} />}
                        />
                      </Box>
                    </Stack>
                  </CardContent>
                </Card>
              );

              function renderNote() {
                return (
                  <Box
                    component={"div"}
                    width={{ xs: "100%", sm: 200 }}
                    padding={"0.5rem"}
                  >
                    {"Ghi chú: " + dk.note}
                  </Box>
                );
              }

              function rendDsQuy() {
                return (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      flexWrap: "wrap",
                    }}
                  >
                    {dk.dsQuy.map((txt, j) => {
                      const a = txt.split(",");
                      return (
                        <div key={j} style={{ margin: "0.5rem" }}>
                          <Chip
                            avatar={<Avatar>{a[0]}</Avatar>}
                            label={`${formatN(a[1])}${a[2]}`}
                          />
                        </div>
                      );
                    })}
                  </div>
                );
              }
            }
          })}
      </Stack>
    </ThemeProvider>
  );
};

export default BtcUser;
/**
 *
 * @param {dayjs} d_curDate
 * @returns ngay AL
 */
export function getDateAL(d_curDate = dayjs()) {
  return getLunarDate(
    d_curDate.date(),
    d_curDate.month() + 1,
    d_curDate.year(),
  );
}

export function CalcTotal(dsQuy) {
  var y = 0;
  var d = 0;
  dsQuy.forEach((q) => {
    if (q.donVi === "y") {
      y += parseInt(q.soLuong);
    } else if (q.donVi === "d") {
      d += parseInt(q.soLuong);
    }
  });
  const total = `${formatN(y)}y, ${formatN(d)}d`;
  return total;
}
/**
 *
 * @param {ngayAL} ngayAL
 * @returns ngayDL YYYY-MM-DD
 */
export function ngayALToDL(ngayAL) {
  var arr = jdn2date(ngayAL.jd).map((x) => x.toString());
  var z_ngayDL =
    arr[2] + "-" + arr[1].padStart(2, "0") + "-" + arr[0].padStart(2, "0");
  return z_ngayDL;
}

function SmallPreview({ value, onOpen }) {
  if (!value) return null;

  const isImage = value.startsWith("data:image/");
  const isPdf = value.startsWith("data:application/pdf");

  return (
    <Box
      onClick={onOpen}
      sx={{
        width: 120,
        height: 120,
        cursor: "pointer",
        border: "1px solid",
        borderColor: "grey.300",
        borderRadius: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        bgcolor: "grey.50",
        "&:hover": { bgcolor: "grey.100" },
      }}
    >
      {/* IMAGE */}
      {isImage && (
        <img
          src={value}
          alt="preview"
          style={{
            maxWidth: "100%",
            maxHeight: "100%",
            objectFit: "cover",
          }}
        />
      )}

      {/* PDF ICON */}
      {isPdf && (
        <Box textAlign="center">
          <PictureAsPdfIcon
            color="error"
            sx={{ fontSize: 40 }}
          />
          <Typography variant="caption">
            PDF
          </Typography>
        </Box>
      )}
    </Box>
  );
}
